import { createContext } from 'react';
import { IItemForGetShortInfo, TLanguageIDs, IUpdateVideoCategory, IVideoCategoryTranslation } from 'types';

export type TEditVideoCategoryVisibleForm = 'mainForm' | 'translations';
export type TTypeOfEditVideoCategoryModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'someTranslationIsEmpty';

export interface IInitialFormData {
	name: string;
	IDsSelectedLanguages: TLanguageIDs[];
	translations: IVideoCategoryTranslation[];
}

export interface IEditVideoCategoryState {
	needRefetchData: boolean;
	initialFormData: IInitialFormData | null;
	categoryID: string;
	visibleForm: TEditVideoCategoryVisibleForm;
	name: string;
	fetchedLanguages: IItemForGetShortInfo[];
	IDsSelectedLanguages: TLanguageIDs[];
	dataForSubmit: IUpdateVideoCategory | null;
	typeOfModalWindow: TTypeOfEditVideoCategoryModalWindow;
	selectedTranslationTab: TLanguageIDs | null;
	translations: IVideoCategoryTranslation[];
}

export const editVideoCategoryInitialState: IEditVideoCategoryState = {
	needRefetchData: false,
	initialFormData: null,
	categoryID: '',
	visibleForm: 'mainForm',
	name: '',
	fetchedLanguages: [],
	IDsSelectedLanguages: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
	selectedTranslationTab: null,
	translations: [],
};

export interface IEditVideoCategoryContext extends IEditVideoCategoryState {
	refetchData(value: boolean): void;
	changeVisibleForm(value: TEditVideoCategoryVisibleForm): void;
	changeName(value: string): void;
	setFetchedLanguages(value: IItemForGetShortInfo[]): void;
	setIDsLanguages(value: TLanguageIDs[]): void;
	setDataForSubmit(data: IUpdateVideoCategory | null): void;
	changeTypeOfModalWindow(value: TTypeOfEditVideoCategoryModalWindow): void;
	setTranslationTab(value: TLanguageIDs | null): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	resetFields(): void;
}

export const EditVideoCategoryContext = createContext<IEditVideoCategoryContext>({
	refetchData: () => undefined,
	changeVisibleForm: () => undefined,
	changeName: () => undefined,
	setFetchedLanguages: () => undefined,
	setIDsLanguages: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	resetFields: () => undefined,
	...editVideoCategoryInitialState,
});
